import { render } from "./HomeLogged.vue?vue&type=template&id=cb3ba71e&scoped=true"
import script from "./HomeLogged.vue?vue&type=script&lang=js"
export * from "./HomeLogged.vue?vue&type=script&lang=js"

import "./HomeLogged.vue?vue&type=style&index=0&id=cb3ba71e&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb3ba71e"]])

export default __exports__